import { render, staticRenderFns } from "./JamieD.vue?vue&type=template&id=46093fe8&"
import script from "./JamieD.vue?vue&type=script&lang=ts&"
export * from "./JamieD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports